import React, { useState, useEffect, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/FAQback.png';
// import backgroundImageLow from '../../assets/FAQback-low.png'; // Раскомментируйте, если у вас есть отдельное изображение низкого качества
import LoaderInside from '../LoaderInside';

const FAQPage = memo(() => {
    const [loading, setLoading] = useState(true);
    const [highResLoaded, setHighResLoaded] = useState(false);
    const navigate = useNavigate();

    // Обработчик загрузки страницы и изображения
    useEffect(() => {
        // Предзагрузка низкокачественного изображения не требуется,
        // если мы используем то же изображение с CSS-эффектом размытия

        // Загрузка высококачественного изображения
        const highResImg = new Image();
        highResImg.src = backgroundImage;

        highResImg.onload = () => {
            // Показываем основное изображение
            setHighResLoaded(true);

            // Скрываем лоадер после загрузки высококачественного изображения
            setTimeout(() => {
                setLoading(false);
            }, 300);
        };

        // Если изображение не загружается за 3 секунды, скрываем лоадер
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 3000);

        return () => clearTimeout(timeout);
    }, []);

    // Обработчик нажатия на кнопки
    const handleButtonClick = (category) => {
        navigate(`/faq/${category}`);
    };

    const addCorners = (buttonClass) => (
        <>
            {/* Верхние полоски */}
            <div className="corner corner-horizontal corner-top-left-h"></div>
            <div className="corner corner-vertical corner-top-left-v"></div>
            <div className="corner corner-horizontal corner-top-right-h"></div>
            <div className="corner corner-vertical corner-top-right-v"></div>

            {/* Нижние полоски */}
            <div className="corner corner-horizontal corner-bottom-left-h"></div>
            <div className="corner corner-vertical corner-bottom-left-v"></div>
            <div className="corner corner-horizontal corner-bottom-right-h"></div>
            <div className="corner corner-vertical corner-bottom-right-v"></div>
        </>
    );

    return (
        <>
            {/* Лоадер на всю страницу */}
            <div className={`faq-page-loader ${loading ? '' : 'hidden'}`}>
                <LoaderInside />
            </div>

            <div className="faq-page-container">
                <div className="faq-page-background">
                    {/* Низкокачественное изображение (используем то же изображение с CSS-размытием) */}
                    <img
                        src={backgroundImage}
                        alt="Фон (низкое качество)"
                        className={`low-res-img ${highResLoaded ? 'hidden' : ''}`}
                    />

                    {/* Высококачественное изображение (показывается после загрузки) */}
                    <img
                        src={backgroundImage}
                        alt="Фон"
                        className={`high-res-img ${highResLoaded ? 'loaded' : ''}`}
                    />
                </div>

                <div className="faq-buttons-container">
                    {/* Кнопка на высоте 20% - Правила игры */}
                    <div className="button-wrapper top-position">
                        <button
                            className="faq-button top-button"
                            onClick={() => handleButtonClick('rules')}
                        >
                            Правила игры
                            {addCorners('top-button')}
                        </button>
                    </div>

                    {/* Кнопка на высоте 65% - Всё об обучении */}
                    <div className="button-wrapper middle-position">
                        <button
                            className="faq-button middle-button"
                            onClick={() => handleButtonClick('learning')}
                        >
                            Всё об обучении
                            {addCorners('middle-button')}
                        </button>
                    </div>

                    {/* Две кнопки в строчку на высоте 75% */}
                    <div className="bottom-buttons-row">
                        <button
                            className="faq-button bottom-button"
                            onClick={() => handleButtonClick('tasks')}
                        >
                            Как выполнять задания
                            {addCorners('bottom-button')}
                        </button>

                        <button
                            className="faq-button bottom-button"
                            onClick={() => handleButtonClick('prizes')}
                        >
                            Как выйграть приз
                            {addCorners('bottom-button')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
});

export default FAQPage; 